import { render, staticRenderFns } from "./Donatii.vue?vue&type=template&id=240d72c6&scoped=true&"
import script from "./Donatii.ts?vue&type=script&lang=ts&"
export * from "./Donatii.ts?vue&type=script&lang=ts&"
import style0 from "./Donatii.vue?vue&type=style&index=0&id=240d72c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d72c6",
  null
  
)

export default component.exports